import { useQuery } from '@tanstack/react-query';
import { releaseHistoryApi } from '../lib/api.js';
import { queryKeys } from '../lib/query-keys.js';

/**
 * @graph-stack ac-mens-hub
 * @graph-domain Engineering
 * @graph-business リリース履歴タイムライン（メンズ main マージPRの発信トーン要約）をカテゴリ・UX影響絞り込み付きで取得するフック。
 * @graph-connects releaseHistoryApi [calls] リリース履歴 API client
 * @graph-connects queryKeys [calls] Query key factory
 */
export function useReleaseTimeline(category?: string, uxImpact?: string) {
  return useQuery({
    queryKey: queryKeys.releaseHistory.timeline(category, uxImpact),
    queryFn: () => releaseHistoryApi.getTimeline({ category, uxImpact }),
    staleTime: 5 * 60_000,
    retry: false,
  });
}
